import { module } from 'modujs'
import { $body, $html } from '../utils/dom'
import Swup from 'swup'
import SwupJsPlugin from '@swup/js-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupA11yPlugin from '@swup/a11y-plugin';
import { CSS_CLASS, CUSTOM_EVENT } from '../config'
import { toDash } from '../utils/string'
import gsap from 'gsap'

export default class extends module {
    constructor(m) {
        super(m)

        // Binding
        this.beforeContentReplace = this.beforeContentReplace.bind(this)
        this.onContentReplace = this.onContentReplace.bind(this)
        this.onVisitStart = this.onVisitStart.bind(this)
        // this.onVisitEnd = this.onVisitEnd.bind(this)
        // this.onAnimationInStart = this.onAnimationInStart.bind(this)
        // this.onScrollAnchor = this.onScrollAnchor.bind(this)
    }

    //////////////
    // Lifecycle
    //////////////

    init() {

        const hash = window.location.hash
        if (hash && document.querySelector(hash)) {
            // Wait the next frame so the Scroll module is initialized
            requestAnimationFrame(() => {
                this.call('scrollTo', { target: document.querySelector(hash) }, 'Scroll')
            })
        };

        // Initialize Swup
        this.load = new Swup({
            containers: ['[data-load-container]'],
            animationSelector: '[class*="u-anim-page"]',
            animateHistoryBrowsing: true,
            linkToSelf: 'navigate',
            ignoreVisit: (url, { el, event } = {}) => {
                if (url.lastIndexOf('#show-cookie-consent') != -1) {
                    return true;
                }
                return el?.closest('[data-no-swup]')
            },
            plugins: [
                new SwupJsPlugin({
                    animations: [
                        this.defaultTransition()
                    ]
                }),
                new SwupA11yPlugin(),
                new SwupA11yPlugin(),
                new SwupPreloadPlugin({ preloadInitialPage: false })
            ]
        })

        // Hooks
        this.load.hooks.on('visit:start', this.onVisitStart)
        // this.load.hooks.on('scroll:anchor', this.onScrollAnchor)
        this.load.hooks.before('content:replace', this.beforeContentReplace)
        this.load.hooks.on('content:replace', this.onContentReplace)
        // this.load.hooks.on('visit:end', this.onVisitEnd)
        // this.load.hooks.on('animation:in:start', this.onAnimationInStart)
    }

    //////////////
    // Hooks
    //////////////

    onScrollAnchor(args) {
        const hash = args.to.hash || null
        const target = hash ? document.querySelector(hash) : null

        requestAnimationFrame(() => {
            target && this.call('scrollTo', { target: target }, 'Scroll')
        })

    }

    onVisitStart(visit) {
        visit.scroll.reset = false;

        // To close all modals if needed
        window.dispatchEvent(new CustomEvent(CUSTOM_EVENT.VISIT_START, { detail: visit }))

        $html.classList.remove(CSS_CLASS.READY)

        // Close all AbstractModal
        for (const modalName of window.modals) {
            this.call('close', null, modalName)
        }

        this.call('resetSticky', 'Header');
    }

    onVisitEnd(visit) {
        window.dispatchEvent(new CustomEvent(CUSTOM_EVENT.VISIT_END, { detail: visit }))

        if (visit.fragmentVisit) {
            // Dispatch custom event
            window.dispatchEvent(new CustomEvent(CUSTOM_EVENT.FRAGMENT_VISIT_END, { detail: visit }))
        }
    }

    async beforeContentReplace(visit) {
        if (visit.fragmentVisit) {
            for (let container of visit.fragmentVisit.containers) {
                const oldContainer = this.el.querySelector(container)
                this.call('removeScrollElements', oldContainer, 'Scroll')
            }
        }

        for (let container of visit.containers) {
            const oldContainer = this.el.querySelector(container)
            this.call('destroy', oldContainer, 'app')
        }
    }

    onContentReplace(visit) {
        const adminBar = document.getElementById('wpadminbar')
        if (adminBar) {
            adminBar.remove();
            let parser = new DOMParser();
            let doc = parser.parseFromString(visit.to.html, "text/html");
            let newAdminBar = doc.getElementById('wpadminbar');
            $body.appendChild(newAdminBar)
        }

        this.updateDocumentAttributes(visit)

        for (let container of visit.containers) {
            const newContainer = this.el.querySelector(container)
            this.call('update', newContainer, 'app')
        }

        setTimeout(() => {
            $html.classList.add(CSS_CLASS.READY)
        }, 100)
    }

    //////////////
    // Methods
    //////////////
    updateDocumentAttributes(visit) {
        if (visit.fragmentVisit) return

        // Retrieve HTML dataset on next container and update our real html element dataset accordingly
        const parser = new DOMParser()
        const nextDOM = parser.parseFromString(visit.to.html, 'text/html')
        const newDataset = Object.assign({}, nextDOM.querySelector('html').dataset)

        Object.entries(newDataset).forEach(([key, val]) => {
            if (key === 'template') {
                $html.setAttribute(`data-${toDash(key)}`, val)
            }
        })

    }

    navigate(args) {
        const { url, options } = args
        this.load.navigate(url, options)
    }

    //////////////
    // Transitions
    //////////////

    defaultTransition() {
        return {
            from: '(.*)',
            to: '(.*)',
            out: (done, data) => {
                gsap.delayedCall(0.5, () => {
                    done();
                });
            },
            in: (done, data) => {
                gsap.delayedCall(1, () => {
                    done();
                });
            }
        };
    }

    seemlessTransition() {
        return {
            from: '(.*)',
            to: 'seemless',
            out: (done, data) => {
                gsap.delayedCall(1, () => {
                    done()
                })
            },
            in: (done, data) => {
                gsap.delayedCall(1, () => {
                    done()
                });

                requestAnimationFrame(() => {
                    window.preventSplitText = false
                })
            }
        };
    }

}
